import tw from 'tailwind-styled-components'

export const TwCell = tw.div`
  min-w-0
  w-full
  flex
  flex-row
  gap-8
  items-center
  group/cell
`

export const TwTooltipText = tw.span`
  break-words
  line-clamp-7
  text-inherit-recursive
`
